import React from 'react';

const App = () => {
    return (
        <>
            <h1 className="text-4xl lg:text-6xl text-blue-700 font-bold p-5 md:p-10">
                Complete the form below to register for Mentally Free, Creatively Free & The Artist Connect App
            </h1>

            <form method="POST" action="https://formspree.io/f/mzbyoypr" className="p-2 md:p-5">
                <div className="flex flex-col md:flex-row">
                    <input name="first_name" type="text" className="flex-1 m-3 md:m-5 p-2" placeholder="First Name" required />

                    <input name="last_name" type="text" className="flex-1 m-3 md:m-5 p-2" placeholder="Last Name" required />
                </div>

                <div className="flex flex-col md:flex-row">
                    <input name="email" type="email" className="flex-1 m-3 md:m-5 p-2" placeholder="Email" required />

                    <input name="phone_number" type="tel" className="flex-1 m-3 md:m-5 p-2" placeholder="Phone Number" required />
                </div>

                <div className="flex flex-row">
                    <input name="occupation" type="text" className="flex-1 m-3 md:m-5 p-2" placeholder="Occupation" required />
                </div>

                <button type="submit" className="bg-blue-700 py-2 px-4 text-white font-bold text-2xl m-3 md:m-5">Submit</button>
            </form>
        </>
    );
};

export default App;
